import { type AttachmentAttributes } from './generated/AttachmentAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface Attachment extends AttachmentAttributes {}

@model
class Attachment extends ApplicationModel {
  // Start auto-generated
  static typename: 'Attachment' = 'Attachment';
  get typename(): 'Attachment' {
    return 'Attachment';
  }

  static fields = {
    contentType: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    downloadUrl: attr({ args: { size: 'AttachmentSizeEnum' }, readable: true }),
    fileName: attr({ readable: true }),
    fileSize: attr({ readable: true }),
    id: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    attachable: attr.belongsTo({ readable: true, typename: ['Note'] }),
    caption: attr.belongsTo({ readable: true, typename: 'Note' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated
}

export default Attachment;
